import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';
import { Feature, Permission } from '@kaseya-shared';
import { Country } from '@core/locations/models/country.enum';
import { signal, WritableSignal } from '@angular/core';
import { adminSettingsViewPermissionsList } from '@core/permissions/constants/permissions.const';

export interface TopNavigationItem {
  id: TopNavigationPath;
  labelTranslateKey: string;
  iconClass: string;
  isCollapsed?: WritableSignal<boolean>;
  permissions?: Permission[];
  features?: Feature[];
  accessibleCountries?: Country[];
}

export const initialTopNavigationItems: TopNavigationItem[] = [
  {
    id: TopNavigationPath.Home,
    labelTranslateKey: 'navigation.top-navigation.home',
    iconClass: 'fa-regular fa-house',
    isCollapsed: signal(true),
  },
  {
    id: TopNavigationPath.Automations,
    labelTranslateKey: 'navigation.top-navigation.automations',
    iconClass: 'fa-regular fa-bolt',
    isCollapsed: signal(true),
  },
  {
    id: TopNavigationPath.Organizations,
    labelTranslateKey: 'navigation.top-navigation.organizations',
    iconClass: 'fa-regular fa-users',
    isCollapsed: signal(true),
  },
  {
    id: TopNavigationPath.BillingAndSubscriptions,
    labelTranslateKey: 'navigation.top-navigation.billing-and-subscriptions',
    iconClass: 'fa-regular fa-receipt',
    isCollapsed: signal(true),
  },
  {
    id: TopNavigationPath.KaseyaInsights,
    permissions: [Permission.BusinessInsightsView],
    features: [Feature.BusinessInsights],
    labelTranslateKey: 'navigation.top-navigation.business-insights',
    iconClass: 'fa-regular fa-chart-mixed',
    isCollapsed: signal(true),
  },
  {
    id: TopNavigationPath.KaseyaStore,
    permissions: [Permission.BillingAndSubscriptions],
    labelTranslateKey: 'navigation.top-navigation.kaseya-store',
    iconClass: 'fa-regular fa-shop',
    isCollapsed: signal(true),
  },
];

export const userSettingsTopNavigationItem: TopNavigationItem = {
  id: TopNavigationPath.UserSettings,
  iconClass: 'fa-regular fa-user-gear',
  labelTranslateKey: 'navigation.top-navigation.my-settings',
  isCollapsed: signal(true),
};

export const adminSettingsTopNavigationItem: TopNavigationItem = {
  id: TopNavigationPath.AdminSettings,
  iconClass: 'fa-regular fa-gear',
  labelTranslateKey: 'navigation.top-navigation.admin-settings',
  permissions: adminSettingsViewPermissionsList,
  isCollapsed: signal(true),
};
